export default "__VITE_ASSET__UKIr9mMU__"